import * as yup from "yup";
import { IsJsonString } from "../../utilities/utilityFunctions";
export const addElectronicToPhysicalValidation = yup.object().shape({
  request_date: yup.string().test("test-date", "Enter Date", (value) => {
    return value;
  }),

  requester_folio: yup.object().nullable().required("Select Folio"),
  company_code: yup.object().nullable().required("Select Company"),
  to_folio: yup.object().nullable().required("Select Folio"),
  no_of_certificates: yup.string().required("Enter Number of Certificate"),
  no_of_shares: yup.string().required("Enter Number of Shares"),
  remarks: yup.string(),
  reference: yup.string(),

  // price: yup.string(),
  // amount: yup.string(),
});

export const updateElectronicToPhysicalValidation = (form) =>
  yup.object().shape({
    request_date: yup
      .string()
      .test("test-date", "Enter Date", (value) => {
        return value;
      })
      .default(form.request_date),
    requester_folio: yup
      .object()
      .required("Select Folio")
      .default(form.folio_number),
    to_folio: yup
      .object()
      .required("Select Folio")
      .default(form.to_folio_number),
    company_code: yup
      .object()
      .required("Select Company")
      .default(form.company_code),

    no_of_certificates: yup
      .string()
      .required("Enter Number of Certificate")
      .default(
        IsJsonString(form.output_certificates)
          ? JSON.parse(form.output_certificates).length
          : 0
      ),
    no_of_shares: yup
      .string()
      .required("Enter Number of Shares")
      .default(form.quantity),
    remarks: yup.string().default(form?.remarks),
    reference: yup.string().default(form?.reference),

    // price: yup.string(),
    // amount: yup.string(),
  });
